/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class GroupFilterService extends Service {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  async fetchFilteredGroups() {
    let groups = await this.store.query('group', {
      year: this.get('dates.currentAcademicYear'),
    });

    return groups.filter((group) => {
      return !!findBy(
        group.currentStaff,
        'personId',
        this.get('session.person.id'),
      );
    });
  }
}
